'use client';

import { createContext } from 'react';
import { UserAgent } from '@/src/interfaces/missing-types';

export const DeviceContext = createContext<UserAgent>({} as UserAgent);
